<template>
  <div id="UiHeader">
    <Logo></Logo>
    <el-menu
      class="header-menus"
      :default-active="activeIndex"
      menu-trigger="click"
      mode="horizontal"
      router
    >
      <menu-item
        v-for="child in menus"
        :key="child.path"
        :menuItem="child"
      ></menu-item>
    </el-menu>
    <!-- right -->
    <div class="hr-btns">
      <!-- <div class="help-document">
        <a href="#/md/help" target="_blank" title="系统帮助文档">
          <img src="../assets/help.png" alt="">&nbsp;在线帮助
        </a>
      </div> -->
    </div>
    <el-dropdown class="hr-dropdown">
      <span class="el-dropdown-link">
        <span>{{ userInfo.username }}<br/>{{ userInfo.deptParentId ? userInfo.deptParentName + '/' + userInfo.deptName : userInfo.deptName }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- <el-dropdown-item>
          <el-switch v-model="alarmNotify" inactive-text="报警信息推送" @change="alarmNotifyChannge"></el-switch>
        </el-dropdown-item> -->
        <el-dropdown-item v-if="$useDeptAuths([3])" @click.native="showPlatformInfo">平台信息</el-dropdown-item>
        <el-dropdown-item v-if="$useRoleAuths(['0', '2'])" @click.native="goOperationLog">操作日志</el-dropdown-item>
        <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
        <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <platformInfo ref="platformInfoRef"></platformInfo>
    <changePassword ref="changePasswordRef"></changePassword>
  </div>
</template>

<script>
import $mitt from '@/utils/mitt';
import { usePremissionStore } from '@/pinia/permission';
import { Notification } from 'element-ui';
import userService from '@/components/service/UserService';
import { loginout } from '@/api/user';
import { getSystemConfigInfo } from '@/api/console';
// 组件
import MenuItem from './components/menuItem.vue';
import Logo from './components/Logo.vue';
import platformInfo from './components/platformInfo.vue';
import changePassword from './components/changePassword.vue';

export default {
  name: 'Header',
  components: {
    Notification,
    MenuItem,
    Logo,
    platformInfo,
    changePassword,
  },
  data() {
    return {
      activeIndex: '',
      alarmNotify: false,
      sseSource: null,
      userInfo: userService.getUser(),
    };
  },
  watch: {
    $route: {
      handler: function(value) {
        this.handleRouteChange(value);
      },
      immediate: true,
    },
  },
  computed: {
    allMenus: function () {
      return usePremissionStore().menus;
    },
    // 头部菜单，只取allMenus中的第一级
    menus: function () {
      return this.allMenus.map((item) => ({ ...item, children: [] }));
    },
  },
  mounted() {
    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // this.alarmNotify = this.getAlarmSwitchStatus() === 'true';
    // TODO: 此处延迟连接 sse, 避免 sse 连接时 browserId 还未生成, 后续待优化
    // setTimeout(() => {
    //   this.sseControl();
    // }, 3000);
  },
  destroyed() {
    // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
    // if (this.sseSource != null) {
    //   this.sseSource.removeEventListener('open', null);
    //   this.sseSource.removeEventListener('message', null);
    //   this.sseSource.removeEventListener('error', null);
    //   this.sseSource.close();
    // }
  },
  methods: {
    handleRouteChange(route) {
      // 遍历所有路由，若当前路由的子路由不为空时，展示侧边拦菜单
      let childs = [];
      let currentRouteChilds = [];
      const traverseRoutes = (arr, paths = []) => {
        arr.forEach((item) => {
          // 提前记录一级菜单的子路由
          if (paths.length === 0) {
            childs = item.children
          }
          if (item.children && item.children.length > 0) {
            traverseRoutes(item.children, [...paths, item.path])
          }

          // 处理动态路由，判断每个位置是否相同
          let isEqual = false;
          if (item.path.includes(':')) {
            const path1 = item.path.split('/');
            const path2 = route.path.split('/');
            for(let i = 0; i < path1.length; i++) {
              if (!path1[i].includes(':')) {
                isEqual = path1[i] === path2[i]
              }
            }
          }
          // 处理静态路由：若为子路由，激活父级path，否则激活当前路由path
          if (item.path === route.path || isEqual) {
            if (paths.length > 0) {
              this.activeIndex = paths[0];
              currentRouteChilds = childs;
            } else {
              this.activeIndex = route.path;
            }
          }
        })
      };
      traverseRoutes(this.allMenus);
      this.$nextTick(() => {
        $mitt.emit('routeChange', currentRouteChilds);
      })
    },
    logout() {
      loginout().then(() => {
        // 删除用户信息，回到登录页面
        userService.clearUserInfo();
        userService.clearAllStorage();
        window.location.reload();
        if (this.sseSource != null) {
          this.sseSource.close();
        }
      })
    },
    changePassword() {
      this.$refs.changePasswordRef.openDialog({
        username: this.username,
        force: false,
        token: '',
      });
    },
    goOperationLog () {
      this.$router.push('/operationLog');
    },
    async showPlatformInfo () {
      const res = await getSystemConfigInfo();
      this.$refs.platformInfoRef.openDialog(res);
    },
    beforeunloadHandler() {
      this.sseSource.close();
    },
    alarmNotifyChannge() {
      this.setAlarmSwitchStatus()
      this.sseControl()
    },
    sseControl() {
      let that = this;
      if (this.alarmNotify) {
        console.log("申请SSE推送API调用，浏览器ID: " + this.$browserId);
        this.sseSource = new EventSource(`${process.env.BASE_API ? process.env.BASE_API : ''}/api/emit?browserId=${this.$browserId}`);
        this.sseSource.addEventListener('message', function (evt) {
          that.$notify({
            title: '报警信息',
            dangerouslyUseHTMLString: true,
            message: evt.data,
            type: 'warning',
            position: 'bottom-right',
            duration: 3000
          });
          console.log("收到信息：" + evt.data);
        });
        this.sseSource.addEventListener('open', function (e) {
          console.log("SSE连接打开.");
        }, false);
        this.sseSource.addEventListener('error', function (e) {
          if (e.target.readyState == EventSource.CLOSED) {
            console.log("SSE连接关闭");
          } else {
            console.log(e.target.readyState);
          }
        }, false);
      } else {
        if (this.sseSource != null) {
          this.sseSource.removeEventListener('open', null);
          this.sseSource.removeEventListener('message', null);
          this.sseSource.removeEventListener('error', null);
          this.sseSource.close();
        }
      }
    },
    getAlarmSwitchStatus() {
      if (localStorage.getItem('alarmSwitchStatus') == null) {
        localStorage.setItem('alarmSwitchStatus', false);
      }
      return localStorage.getItem('alarmSwitchStatus');
    },
    setAlarmSwitchStatus() {
      localStorage.setItem('alarmSwitchStatus', this.alarmNotify);
    }
  },
}
</script>

<style lang="scss" scoped>
#UiHeader {
  display: flex;
  height: 100%;
  background: linear-gradient(to right, transparent 15%, rgba(57, 127, 205, 1), transparent), url('../assets/header-bg.jpg');
  // background: url('../assets/header-bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0 20px;
  .hr-btns {
    height: 100%;
    display: flex;
    align-items: center;
    .help-document {
      height: 16px;
      margin-right: 25px;
      cursor: pointer;
      a {
        color: #fff;
        text-decoration: none;
        font-size: 14px;
        &:hover {
          text-decoration: underline;
        }
      }
      img {
        height: 100%;
        vertical-align: middle;
      }
    }
  }
  .hr-dropdown .el-dropdown-link {
    height: 100%;
    display: flex;
    align-items: center;
    color: var(--app-color-white);
    // text-align: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/header.vue